import styled from 'styled-components'

export default styled.button`
	background: ${props => (props.disabled ? 'LightGray' : 'SlateBlue')};
	border: none;
	border-radius: 8px;
	color: white;
	cursor: pointer;
    line-height: 1.6;
    margin: 10px 0;
    text-align: center;
`



// WEBPACK FOOTER //
// ./src/primitives/Button.js